import styled from "styled-components";

export const MainContent = styled.div`
  flex: 1;
  display: flex;
  background-color: white;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  width: 100vw;
  margin-top: 5%;
  padding: 24px;
`;

export const ContainerStyled = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  flex: 1;
  justify-content: center;
  align-items: center;
  background-color: white;
`;

export const ContentStyled = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  flex: 1;
  justify-content: center;
  align-items: center;
`;

export const TitleStyled = styled.h1`
  font-size: 32px;
  font-weight: 600;
  color: #000;
  padding: 20px;
`;

export const ButtonText = styled.h3`
  font-size: 24px;
  font-weight: 600;
  color: white;
  text-align: center;
`;

export const HighlightStyled = styled.h3`
  font-weight: 700;
`;

export const ButtonStyled = styled.button`
  min-width: 70px;
  width: 6vw;
  margin: 10px;
  border-radius: 5px;
  align-items: center;
  justify-content: center;
  background-color: ${(props) => props.bgColor};
`;

export const TextBoxStyled = styled.input`
  border: dashed 3px gray;
  height: 180px;
  width: 70%;
  border-radius: 5px;
  text-align: center;
  font-size: 24px;
  font-weight: 600;
  background-color: white;
  margin-bottom: 10px;
`;
